import { IState } from 'legacy/lut/store'

export const selectMarketInfoState = (state: IState) => state.partner360.marketInfo
